import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isSubscriptionRequired } from '../api/errors';
import { useSubscription } from '../api/hooks';
import { useOrgId } from '../auth/store';
import { Skeleton } from '../ui';
import { needsOffer, useSubscriptionGate } from './gate';

/**
 * Le choix de l'offre précède toute autre page : sans offre active (plan gratuit, essai échu ou non démarré),
 * la console est fermée et l'utilisateur est redirigé vers « Choisir une offre ». Remote n'est pas concerné.
 */
export function RequireSubscription() {
  const org = useOrgId();
  const flagged = useSubscriptionGate((s) => s.requiredOrg === org);
  const sub = useSubscription();
  const location = useLocation();

  if (flagged || isSubscriptionRequired(sub.error) || (sub.data && needsOffer(sub.data.planId))) {
    return <Navigate to="/choose-plan" replace state={{ from: location.pathname + location.search }} />;
  }
  if (sub.isPending) {
    return (
      <div role="status" aria-busy="true" style={{ display: 'grid', gap: 16, padding: 24 }}>
        <Skeleton height={36} width={280} />
        <Skeleton height={160} radius={20} />
      </div>
    );
  }
  return <Outlet />;
}
